import * as React from 'react'

import type { CustomFieldProps } from './typings'

import { CustomText } from './CustomText'
import { CustomDate } from './CustomDate'
import { CustomNumber } from './CustomNumber'
import { CustomCheckbox } from './CustomCheckbox'
import { CustomMultiSelect } from './CustomMultiSelect'
import { CustomSingleSelect } from './CustomSingleSelect'

export function CustomField(props: CustomFieldProps) {
  const { value, ...rest } = props

  switch (value.type) {
    case 'Text':
      return <CustomText {...rest} value={value} />
    case 'Date':
      return <CustomDate {...rest} value={value} />
    case 'Number':
      return <CustomNumber {...rest} value={value} />
    case 'Checkbox':
      return <CustomCheckbox {...rest} value={value} />
    case 'DropdownMultiSelect':
      return <CustomMultiSelect {...rest} value={value} />
    case 'DropdownSingleSelect':
      return <CustomSingleSelect {...rest} value={value} />
    default:
      return null
  }
}
